module.exports = __webpack_public_path__ + "img/symbol_7.dfcf7577.png";